// MYAC-1571 — the Firestore rule (`validNameValue`) a company, QMS or product
// name must meet: a non-empty string of at most 120 characters, without < or >.
// The rules are the gate; this mirror only lets a refused request say whether
// the names are why, instead of blaming them for every refusal.
export const NAME_MAX_LENGTH = 120

/** True when the rules would refuse this name. Firestore counts characters,
 * not UTF-16 units, hence the spread. */
export function breaksNameRule(name: string): boolean {
  const length = [...name].length
  return length === 0 || length > NAME_MAX_LENGTH || /[<>]/.test(name)
}
